import React, {Component, Fragment} from 'react';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import DEFINE, { CONFIG_PHS_ENUM } from "../../../../constants/Define";
import { Button, InputNumber, Switch, Skeleton } from 'antd';
import './ConfigPHS.less';
import Wrapper from '../../common/component/Wrapper';
import ConfigPHS from '../../../../models/ConfigPHS';
import { isEqual, cloneDeep } from 'lodash';
export default class ConfigPHSInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isEdit: false,
            isWarning: false,
            isTimeValid: false
        }
    }

    render() {
        const { t, type, configPhs } = this.props;
        const { isEdit, isWarning, isTimeValid } = this.state;
        return (
            <Fragment>
                <div className="config-phs-com">
                    <div className="form-config-phs row col-md-4">
                        <Skeleton loading={this.props.configPHSState.isFetching}>
                            <Wrapper className="col-md-12 title">{t('item.configPHS.title')}</Wrapper>
                            <Fragment>
                                <Wrapper className="col-md-8 fw-500">
                                    {t('item.configPHS.isActive')}
                                </Wrapper>
                                <Wrapper className="col-md-4">
                                    {
                                        isEdit ?
                                            <Switch 
                                                checked={ configPhs.isActive } 
                                                checkedChildren={t('item.configPHS.turnOn')}
                                                unCheckedChildren={t('item.configPHS.turnOff')}
                                                onChange={ check => this.onChange('isActive', check) }
                                            />
                                        : <span style={{color: configPhs.isActive ? 'green' : 'red'}}>{t(`item.configPHS.${CONFIG_PHS_ENUM['ACTIVE'][configPhs.isActive]}`)}</span>
                                    }
                                </Wrapper>
                            </Fragment>
                            <Fragment>
                                <Wrapper className="col-md-8 fw-500">
                                    {t('item.configPHS.sessionLiveTime')}
                                </Wrapper>
                                <Wrapper className="col-md-4">
                                    {
                                        isEdit ?
                                            <InputNumber 
                                                style={{width: '100%'}}
                                                value={ Func.checkUndefine(configPhs.sessionLiveTime) }
                                                onChange={(e)=> this.onChange('sessionLiveTime', e)}
                                                min={0}
                                            />
                                        : <span>{configPhs.sessionLiveTime} ({t('item.configPHS.timeUnit')})</span>
                                    }
                                </Wrapper>
                            </Fragment>
                            <Fragment>
                                <Wrapper className="col-md-8 fw-500">
                                    {t('item.configPHS.paymentTime')}
                                </Wrapper>
                                <Wrapper className="col-md-4">
                                    {
                                        isEdit ?
                                            <InputNumber 
                                                style={{width: '100%'}}
                                                value={ Func.checkUndefine(configPhs.paymentTime) }
                                                onChange={(e)=> this.onChange('paymentTime', e)}
                                                min={0}
                                            />
                                        : <span>{configPhs.paymentTime} ({t('item.configPHS.timeUnit')})</span>
                                    }
                                </Wrapper>
                            </Fragment>
                            { type === 'Bundle' && <Fragment>
                                <Wrapper className="col-md-8 fw-500">
                                    {t('item.configPHS.countOfReset')}
                                </Wrapper>
                                <Wrapper className="col-md-4">
                                    {
                                        isEdit ?
                                            <InputNumber 
                                                style={{width: '100%'}}
                                                value={ Func.checkUndefine(configPhs.countOfReset) }
                                                onChange={(e)=> this.onChange('countOfReset', e)}
                                                min={0}
                                            />
                                        : <span>{configPhs.countOfReset} ({t('item.configPHS.countUnit')})</span>
                                    }
                                </Wrapper>
                            </Fragment> }
                            <Wrapper className="col-md-12 btn-edit">
                                {isWarning && <span className="config-phs-warning mr-10">{t(`item.configPHS.warningEdit`)}</span>}
                                { isEdit && <Button style={{marginRight: 10}} onClick={this.onCancelEdit}>{t(`item.configPHS.cancel`)}</Button> }
                                <Button loading={this.props.configPHSState.isUpdateFetching} type="primary" onClick={this.onEditPHS}>{t(`item.configPHS.${isEdit ? 'save' : 'edit'}`)}</Button>
                                {isTimeValid && <div className="config-phs-warning">{t(`validation.statusCode.code.PHS_CONFIG_NOT_VALID`)}</div>}
                            </Wrapper>
                        </Skeleton>
                    </div>
                </div>
            </Fragment>
        );
    }

    onEditPHS = ()=>{
        const { isEdit } = this.state;
        const { configPhs } = this.props;
        if(isEdit){
            let isPassEdit = false;
            if(configPhs.sessionLiveTime && configPhs.paymentTime){
                isPassEdit = true;
                if(configPhs.type === 'Bundle' && !configPhs.countOfReset){
                    isPassEdit = false;
                }
            }
            if(isPassEdit){
                if(configPhs.sessionLiveTime <= configPhs.paymentTime){
                    this.setState({isTimeValid: true});
                    return;
                }
                this.props.updateConfigPHS(configPhs); 
            }else{
                this.setState({isWarning: true});
                return;
            }
        }
        this.setState({ isEdit: !isEdit });
    }

    onCancelEdit = ()=> {
        this.setState({
            isEdit: false,
            isWarning: false,
            isTimeValid: false
        })
        this.props.onCancelEdit();
    }

    onChange = (fieldName, value)=>{
        this.setState({ isWarning: false, isTimeValid: false });
        this.props.onChange(fieldName, value);
    }
}

